module.exports = __webpack_public_path__ + "img/huabg.2c1e6d11.png";